export default __webpack_public_path__ + "static/media/create.f1fe78bf.svg";